import React, { forwardRef, Fragment, useState } from "react";
import { connect, MapStateToProps } from "react-redux";

import { Divider, FontWeight, Icon, Text, WhiteSpace } from "@multiweb/reactComponents";
import { bridge } from "@multiweb/reactCore/bridge";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { ForwardRefType, IAppState } from "@multiweb/types/react";

export type SideListFrameItemComponentProps = {
    readonly isSelected: boolean;
    readonly headerName: string;
    readonly headerLocKey: string;
    readonly description1?: string;
    readonly description2?: string;
    readonly description3?: string;
    readonly iconName?: string;
    readonly onItemClick: () => void;
    readonly headerText: string;
};

const classNames = bemClassNames("side-list-frame-item-component");
const headerItemContainer = classNames("header-item-container");
const iconSection = classNames("icon-section");
const { valueToEnumValue } = bridge;

const SideListFrameItemComponent: ForwardRefType<HTMLDivElement, SideListFrameItemComponentProps> = forwardRef<HTMLDivElement, SideListFrameItemComponentProps>(({
    isSelected,
    headerName,
    description1,
    description2,
    description3,
    iconName,
    onItemClick,
    headerText,
}, forwardRef) => {
    const [isMouseOver, setIsMouseOver] = useState(false);

    const iconCode: IconCode | undefined = valueToEnumValue(IconCode, iconName ?? "");

    const handleOnMouseOver = () => {
        if (!isMouseOver)
            setIsMouseOver(true);
    };

    const handleOnMouseLeave = () => {
        if (isMouseOver)
            setIsMouseOver(false);
    };

    return ( // Promyslet, jestli nevyužít pak rozdělení na xxx.tsx a xxxComponent.tsx, ať tu neřešíme ty lokalizace :)
        <Fragment>
            <div ref={forwardRef} className={classNames({ "is-mouse-over": isMouseOver, "selected": isSelected })} onClick={onItemClick} onMouseOver={handleOnMouseOver} onMouseLeave={handleOnMouseLeave}>
                <Text value={headerText === "" ? headerName : headerText} ellipsis whiteSpace={WhiteSpace.nowrap} isTextSelectable={false} fontWeight={FontWeight.bold} />
                <div className={headerItemContainer}>
                    {iconCode &&
                        <div className={iconSection}>
                            <Icon iconCode={iconCode}></Icon>
                        </div>}
                    {description1 && <Text value={description1} title={description1} disabled ellipsis isTextSelectable={false} whiteSpace={WhiteSpace.nowrap} fontWeight={FontWeight.bold} />}
                    {description2 && <Text value={description2} title={description2} disabled ellipsis isTextSelectable={false} whiteSpace={WhiteSpace.nowrap} fontWeight={FontWeight.bold} />}
                    {description3 && <Text value={description3} title={description3} disabled ellipsis isTextSelectable={false} whiteSpace={WhiteSpace.nowrap} fontWeight={FontWeight.bold} />}
                </div>
            </div>
            <Divider />
        </Fragment>
    );
});

type StateProps = Pick<SideListFrameItemComponentProps, "headerText">;
type SideListFrameItemProps = Pick<SideListFrameItemComponentProps, "headerLocKey">;

const mapStateToProps: MapStateToProps<StateProps, SideListFrameItemProps, IAppState> = (state, { headerLocKey }) => ({
    headerText: getPrimaryText(state, headerLocKey) ?? "",
});

export const SideListFrameItem = connect(mapStateToProps, undefined, undefined, { forwardRef: true })(SideListFrameItemComponent);
